import { Switch } from "shared/components/forms/Switch";
import { Tabs } from "shared/components/Tabs";
import { NotificationKind } from "../types";

interface LayoutHeaderProps {
  unreadOnly: boolean;
  toggleUnreadOnly: () => void;
  tab: string;
  onTabChange: (tab: string) => void;
  unreadTotalCount: number;
  unreadMentionCount: number;
  unreadAssignedCount: number;
}

export const LayoutHeader = (props: LayoutHeaderProps) => {
  const {
    unreadOnly,
    toggleUnreadOnly,
    tab,
    onTabChange,
    unreadMentionCount,
    unreadAssignedCount
  } = props;

  return (
    <div className="divide-y divide-alpha-40">
      <div className="flex gap-4 p-6">
        <h1 className="text-2xl font-bold">Notifications</h1>
        <Switch
          label="Only unread"
          wrapperClassName="mt-2"
          className="text-sm font-medium text-content-500"
          checked={unreadOnly}
          onChange={() => toggleUnreadOnly()}
        />
      </div>

      <div className="p-4 pb-0">
        <Tabs
          selected={tab}
          setActiveTab={(t) => onTabChange(t)}
          tabs={[NotificationKind.Mention, NotificationKind.Assigned]}
          variant="underline"
          tabClassName="!px-0"
          displayMap={{
            [NotificationKind.Mention]: (
              <p className="mb-2">
                Mentions{" "}
                {unreadMentionCount ? (
                  <span className="px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded-md font-bold">
                    {unreadMentionCount}
                  </span>
                ) : (
                  ""
                )}
              </p>
            ),
            [NotificationKind.Assigned]: (
              <p className="mb-2">
                Assigned{" "}
                {unreadAssignedCount ? (
                  <span className="px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded-md font-bold">
                    {unreadAssignedCount}
                  </span>
                ) : (
                  ""
                )}
              </p>
            )
          }}
        />
      </div>
    </div>
  );
};
